import { interpolate, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';

/**
 * Component used to display mostly text content coming from CMS in different
 * decorative variants. Allows to display Markdown or HTML content.
 */
var TextComponent = /** @class */ (function (_super) {
    __extends(TextComponent, _super);
    function TextComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextComponent.prototype, "processedText", {
        get: function () {
            var interpolateParams = this.magicConfig.interpolationParams;
            if (this.params) {
                interpolateParams = __assign(__assign({}, interpolateParams), this.params);
            }
            return interpolate(this.content || '', interpolateParams, this.isMarkdown);
        },
        enumerable: false,
        configurable: true
    });
    TextComponent.prototype.updated = function () {
        this.onTextLoad();
    };
    /**
     * Emitted once the content has been mounted and rendered
     * into the page.
     */
    TextComponent.prototype.onTextLoad = function () {
        return;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TextComponent.prototype, "content", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TextComponent.prototype, "unsafeContent", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "isMarkdown", void 0);
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], TextComponent.prototype, "params", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TextComponent.prototype, "tag", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "offerText", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "promotionText", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "landingPageText", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "contentText", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "carouselText", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "carouselEnhancedText", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "marketingBannerText", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "noInheritance", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "inheritWeight", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "ellipsis", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], TextComponent.prototype, "primary", void 0);
    __decorate([
        Emit('textLoad'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextComponent.prototype, "onTextLoad", null);
    TextComponent = __decorate([
        Component({
            name: 'ui-text',
        })
    ], TextComponent);
    return TextComponent;
}(Mixins(MagicConfigMixin)));

export default TextComponent;
